import React, { FC, memo } from 'react';

import usePrefix from 'utils/usePrefix';
import Button from 'components/Button';
import TextAreaComponent from 'components/TextAreaComponent';

import { INPUT_CHARS_LIMIT } from '../constants';
import { FormItemActionsStyled, FormItemStyled } from 'components/ResqlExpert/formItemStyles';

interface Props {
  group: string;
  index: number;
  label: string;
  placeholder?: string;
  value: string;
  onChange: (index: number, value: string) => void;
  onRemove?: (index: number) => void;
  limit?: number;
}

const FormItemText: FC<Props> = ({
  group,
  index,
  label,
  placeholder,
  value,
  onChange,
  onRemove,
  limit = INPUT_CHARS_LIMIT,
}) => {
  const t = usePrefix('ResqlExpert');

  return (
    <FormItemStyled>
      <TextAreaComponent
        id={`${group}-${index}`}
        label={`${label} ${index + 1}`}
        limit={limit}
        placeholder={placeholder}
        text={value}
        setText={(v) => onChange(index, v)}
      />
      {index > 0 && onRemove ? (
        <FormItemActionsStyled>
          <Button
            color="secondary"
            title={t('ctaRemove')}
            onClick={() => onRemove(index)}
            label={t('ctaRemove')}
          />
        </FormItemActionsStyled>
      ) : null}
    </FormItemStyled>
  );
};

export default memo(FormItemText);
